import Button from "../components/Button/Button";
import AlertIcon from "../assets/svg/alert-icon";
import Input from "../components/Input/Input";
import TextArea from "../components/TextArea/TextArea";
import ToggleSwitch from "../components/ToggleSwitch/ToggleSwitch";
import { useState, useCallback, useEffect } from "react";
import HomeSearchIcon from "../assets/svg/v1/home-search-icon";
import UserIcon from "../assets/svg/user-icon";
import SettingsIcon from "../assets/svg/settings-icon";
import TabPanel from "../components/TabPanel/TabPanel";
import SearchBar from "../components/SearchBar/SearchBar";
import { SuggestionItem } from "../components/SearchBar/types";
import { Avatar } from "../components/Avatar/Avatar";
import Dropdown from "../components/Dropdown/Dropdown";
import UserIcon2 from "../assets/svg/user-icon";
import EmailIcon from "../assets/svg/v1/email-icon";
import PhoneIcon from "../assets/svg/v1/phone-icon";
import CalendarFilledIcon from "../assets/svg/v1/calendar-filled-icon";
import StarIcon from "../assets/svg/star-icon";
import BookmarkIcon from "../assets/svg/v1/bookmark-icon";
import BackspaceFilledIcon from "../assets/svg/v1/backspace-filled-icon";
import ClockFilledIcon from "../assets/svg/v1/clock-filled-icon";
import MultiSelectSearchableDropdown from "../components/MultiSelectSearchableDropdown/MultiSelectSearchableDropdown";
import { MultiSelectDropdownOption } from "../components/MultiSelectSearchableDropdown/types";
import { DropdownOption } from "../components/Dropdown/types";
import Drawer from "../components/SideDrawer/SideDrawer";
import SearchableDropdown from "../components/SearchableDropdown/SearchableDropdown";
import { SearchableDropdownOption } from "../components/SearchableDropdown/types";
import PhoneNumberCountryCodeSelector from "../components/PhoneNumberCountryCodeSelector/PhoneNumberCountryCodeSelector";
import {
  PhoneNumberData,
  CountryOption,
} from "../components/PhoneNumberCountryCodeSelector/utils/types";
import {
  transformCountryOptions,
  sortCountryOptions,
  findCountryByCode,
  formatPhoneNumber,
  validatePhoneNumber,
} from "../components/PhoneNumberCountryCodeSelector/utils/phoneNumberUtils";
import { countryOptions } from "../utils/constants/countryOptions";
import Accordion from "../components/Accordion/Accordion";
import LeadCard from "../components/LeadCard/LeadCard";
import ChatExportModal from "./Communications/components/ChatExportModal/ChatExportModal";
import SingleDatePicker from "../components/SingleDatePicker/SingleDatePicker";
import CalendarIcon from "../assets/svg/calendar-icon";
import DurationPopper from "../components/DurationPopper/DurationPopper";
import TextMessageBlock from "../components/ConversationBlocks/TextMessageBlock";
import FeedbackMessageBlock from "../components/ConversationBlocks/FeedbackMessageBlock";
import AISummaryBlock from "../components/ConversationBlocks/AISummaryBlock";
import AICallTranscript from "../components/ConversationBlocks/AICallTranscript";
import VoiceCallMessageBlock from "../components/ConversationBlocks/VoiceCallMessageBlock";
import VoiceCallPlayer from "../components/ConversationBlocks/VoiceCallPlayer";
import TimePicker from "../components/TimePicker/TimePicker";
import ScheduledIcon from "../assets/svg/scheduled-icon";
import PropertyCardsCarousel from "../components/ConversationBlocks/PropertyCardsCarousel";
import RichTextEditor from "../components/RichTextEditor/RichTextEditor";
import RichTextEditorToolbar from "../components/RichTextEditor/RichTextEditorToolbar";
import { Editor } from "@tiptap/react";

const SEARCH_DATA = [
  {
    leadName: "Tushar Jade",
    leadId: "#46095804",
  },
  {
    leadName: "Alfie Smith",
    leadId: "#85236971",
  },
  {
    leadName: "Niamh O'Connor",
    leadId: "#98765432",
  },
  {
    leadName: "Emily Rodriguez",
    leadId: "#73041829",
  },
  {
    leadName: "James Thompson",
    leadId: "#29583746",
  },
  {
    leadName: "Sarah Chen",
    leadId: "#91647382",
  },
  {
    leadName: "Michael Johnson",
    leadId: "#58294637",
  },
  {
    leadName: "Priya Patel",
    leadId: "#84739251",
  },
  {
    leadName: "David Williams",
    leadId: "#36194758",
  },
  {
    leadName: "Maria Garcia",
    leadId: "#92648175",
  },
  {
    leadName: "Alex Kim",
    leadId: "#47382916",
  },
  {
    leadName: "Sophie Anderson",
    leadId: "#65847392",
  },
  {
    leadName: "Ryan Martinez",
    leadId: "#18374629",
  },
];

const accordionData = [
  {
    id: "welcome-students",
    title: "Welcome Students to Vita",
    content: (
      <div className="space-y-4">
        <p className="text-verba-indigo dark:text-verba-indigo-dk">
          The AI felt conversational and easy to interact with. It understood my
          needs quickly and guided me step-by-step. Booking student
          accommodation has never been this smooth!
        </p>
        <hr className="border-gray-200" />
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Campaign Sent
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              23 Jun 2025
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Name
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              John Smith
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Phone
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              9876578908
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Email
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              johnclaudevandam23@gmail.com
            </span>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: "personal-details",
    title: "Personal Details",
    content: (
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Name
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Alice Smith
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            ID
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            234566432
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Phone
          </span>
          <div className="flex items-center gap-2">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              9876578908
            </span>
            <span className="px-2 py-1 text-xs bg-yellow-100 text-yellow-700 rounded-full">
              Unverified
            </span>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Email
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            johnclaudevandam23@gmail.com
          </span>
        </div>
      </div>
    ),
  },
  {
    id: "academic-info",
    title: "Academic Information",
    content: (
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            University
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            MIT University
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Course
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Computer Science
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Year
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            3rd Year
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Student ID
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            MIT2023CS001
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Status
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
      </div>
    ),
  },
  {
    id: "accommodation-details",
    title: "Accommodation Details",
    content: (
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Property
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Vita Student - London Bridge
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Room Type
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Studio Premium
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Check-in
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            15 Sep 2024
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Check-out
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            30 Jun 2025
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Rent
          </span>
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            £1,250/month
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Payment Status
          </span>
          <span className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full">
            Paid
          </span>
        </div>
      </div>
    ),
  },
  {
    id: "communication-history",
    title: "Communication History",
    content: (
      <div className="space-y-4">
        <div className="border-l-4 border-blue-500 pl-4">
          <div className="flex justify-between items-start mb-2">
            <span className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
              Welcome Email
            </span>
            <span className="text-xs text-verba-indigo dark:text-verba-indigo-dk">
              2 hours ago
            </span>
          </div>
          <p className="text-sm text-verba-indigo dark:text-verba-indigo-dk">
            Welcome to Vita Student! Your booking has been confirmed.
          </p>
        </div>
        <div className="border-l-4 border-green-500 pl-4">
          <div className="flex justify-between items-start mb-2">
            <span className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
              Check-in Reminder
            </span>
            <span className="text-xs text-verba-indigo dark:text-verba-indigo-dk">
              1 day ago
            </span>
          </div>
          <p className="text-sm text-verba-indigo dark:text-verba-indigo-dk">
            Don't forget to bring your ID and payment confirmation.
          </p>
        </div>
        <div className="border-l-4 border-yellow-500 pl-4">
          <div className="flex justify-between items-start mb-2">
            <span className="text-sm font-medium text-verba-indigo dark:text-verba-indigo-dk">
              Maintenance Notice
            </span>
            <span className="text-xs text-verba-indigo dark:text-verba-indigo-dk">
              3 days ago
            </span>
          </div>
          <p className="text-sm text-verba-indigo dark:text-verba-indigo-dk">
            Scheduled maintenance in common areas on Friday.
          </p>
        </div>
      </div>
    ),
  },

  {
    id: "financial-summary",
    title: "Financial Summary",
    content: (
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center p-3 bg-green-50 rounded-lg">
            <div className="text-2xl font-bold text-green-600">£3,750</div>
            <div className="text-sm text-verba-indigo dark:text-verba-indigo-dk">
              Total Paid
            </div>
          </div>
          <div className="text-center p-3 bg-blue-50 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">£1,250</div>
            <div className="text-sm text-verba-indigo dark:text-verba-indigo-dk">
              Next Payment
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Deposit
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              £500
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Monthly Rent
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              £1,250
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Utilities
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Included
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Payment Method
            </span>
            <span className="text-verba-indigo dark:text-verba-indigo-dk">
              Direct Debit
            </span>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: "facility-access",
    title: "Facility Access",
    content: (
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Gym Access
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Study Rooms
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Laundry
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Common Areas
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Parking
          </span>
          <span className="px-2 py-1 text-xs bg-red-100 text-red-700 rounded-full">
            Not Available
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-verba-indigo dark:text-verba-indigo-dk">
            Bike Storage
          </span>
          <span className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded-full">
            Active
          </span>
        </div>
      </div>
    ),
  },
];

const tabs = [
  {
    id: "home",
    label: "Home",
    icon: HomeSearchIcon,
    count: 12,
    tooltip: "View your dashboard and recent activity",
  },
  {
    id: "users",
    label: "Users",
    icon: UserIcon,
    count: 247,
    tooltip: "Manage user accounts and permissions",
  },
  {
    id: "settings",
    label: "Settings",
    icon: SettingsIcon,
    count: 3,
    tooltip: "Configure application settings and preferences",
  },
];

const priorityOptions: DropdownOption[] = [
  {
    value: "low",
    content: (
      <div className="flex items-center gap-1">
        <div className="w-2 h-2 shrink-0 rounded-full bg-green-500"></div>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Low Priority
        </span>
      </div>
    ),
  },
  {
    value: "medium",
    content: (
      <div className="flex items-center gap-1">
        <div className="w-2 h-2 shrink-0 rounded-full bg-yellow-500"></div>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Medium Priority
        </span>
      </div>
    ),
  },
  {
    value: "high",
    content: (
      <div className="flex items-center gap-1">
        <div className="w-2 h-2 shrink-0 rounded-full bg-red-500"></div>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          High Priority
        </span>
      </div>
    ),
  },
  {
    value: "urgent",
    content: (
      <div className="flex items-center gap-1">
        <div className="w-2 h-2 shrink-0 rounded-full bg-red-700 animate-pulse"></div>
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk font-semibold">
          Urgent
        </span>
      </div>
    ),
  },
];

const statusOptions: DropdownOption[] = [
  {
    value: "active",
    content: (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        Active
      </div>
    ),
  },
  {
    value: "inactive",
    content: (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        Inactive
      </div>
    ),
  },
  {
    value: "pending",
    content: (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        Pending
      </div>
    ),
  },
  {
    value: "archived",
    content: (
      <div className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
        Archived
      </div>
    ),
  },
];

const userOptions: MultiSelectDropdownOption[] = [
  {
    value: "john-doe",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          John Doe
        </span>
      </div>
    ),
  },
  {
    value: "jane-smith",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Jane Smith
        </span>
      </div>
    ),
  },
  {
    value: "mike-johnson",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Mike Johnson
        </span>
      </div>
    ),
  },
  {
    value: "sarah-wilson",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Sarah Wilson
        </span>
      </div>
    ),
  },
  {
    value: "david-brown",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          David Brown
        </span>
      </div>
    ),
  },
  {
    value: "emma-davis",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Emma Davis
        </span>
      </div>
    ),
  },
  {
    value: "alex-miller",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Alex Miller
        </span>
      </div>
    ),
  },
  {
    value: "lisa-garcia",
    content: (
      <div className="flex items-center gap-2">
        <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Lisa Garcia
        </span>
      </div>
    ),
  },
];

const categoryOptions: MultiSelectDropdownOption[] = [
  {
    value: "email",
    content: (
      <div className="flex items-center gap-2">
        <EmailIcon className="w-3 h-3 text-blue-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Email Marketing
        </span>
      </div>
    ),
  },
  {
    value: "phone",
    content: (
      <div className="flex items-center gap-2">
        <PhoneIcon className="w-3 h-3 text-green-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Phone Calls
        </span>
      </div>
    ),
  },

  {
    value: "calendar",
    content: (
      <div className="flex items-center gap-2">
        <CalendarFilledIcon className="w-3 h-3 text-purple-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Scheduled
        </span>
      </div>
    ),
  },

  {
    value: "star",
    content: (
      <div className="flex items-center gap-2">
        <StarIcon className="w-3 h-3 text-yellow-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Starred
        </span>
      </div>
    ),
  },

  {
    value: "bookmark",
    content: (
      <div className="flex items-center gap-2">
        <BookmarkIcon className="w-3 h-3 text-indigo-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Bookmarked
        </span>
      </div>
    ),
  },
  {
    value: "bell",
    content: (
      <div className="flex items-center gap-2">
        <BackspaceFilledIcon className="w-3 h-3 text-cyan-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Notifications
        </span>
      </div>
    ),
  },
  {
    value: "clock",
    content: (
      <div className="flex items-center gap-2">
        <ClockFilledIcon className="w-3 h-3 text-gray-500 shrink-0" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
          Recent
        </span>
      </div>
    ),
  },
];

const PROPERTY_CAROUSEL_DATA = {
  channel: "widget",
  message_id: "689d1e8ad006cde0e070cb86_2",
  id: "5e5ffd71-0b73-43ca-a3da-39b2ec032548",
  ai_response_time_in_seconds: 25.515553,
  content:
    "Based on what you're looking for, a studio room in London with a budget of £400 per week and a 6-month lease, We have the options that are the Perfect match to your requirements",
  transcript_text:
    "Thank you, Aakash! It's lovely to assist you. We've noted your preferences for a studio room near University College London, with a 6-month stay and a budget of £400 per week. Here are some fantastic options that might suit your needs:\n\n*   **Islington II**\n    *   Room Name: Bronze Studio\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £375/week\n    *   Residence Link: https://londonist.co.uk/residences/islington-ii_42?&academic_year_id=8\n\n*   **Finsbury House**\n    *   Room Name: Classic Studio\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £275/week\n    *   Residence Link: https://www.londonist.co.uk/residences/finsbury-house_16\n\n*   **Highbury Residence**\n    *   Room Name: Bronze Studio Mid Level\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £420/week\n    *   Residence Link: https://www.londonist.co.uk/residences/highbury-residence_12\n\n*   **Islington Residence**\n    *   Room Name: Bronze Studio Upper Level\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £310/week\n    *   Residence Link: https://www.londonist.co.uk/residences/islington-residence_6\n\n*   **Highbury II Residence**\n    *   Room Name: Silver Studio Lower Level\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £455/week\n    *   Residence Link: https://www.londonist.co.uk/residences/highbury-ii-residence_13\n\nWe offer airport pickup service as well, and you can get great discounts on the properties when booking with us. Do you want to know more about us?\n\n_Note: The availability and pricing depends on your requirements and subject to change without prior notice._",
  role: "assistant",
  cc: [],
  bcc: [],
  attachments: [],
  bot_version: "v1",
  translated_content: "",
  language: "en",
  kind: "chat",
  property_json:
    '[{"property_id": 170, "configuration_id": 310, "room_name": "Bronze Studio", "property_name": "Islington II", "amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/islington-ii/Bronze_Studio.jpeg", "source_link": "https://londonist.co.uk/residences/islington-ii_42?&academic_year_id=8", "lease": 26, "price": 375, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "available_from": "09 Aug 2026", "bed_available": "6", "client_name": "Prestige Student "}, {"property_id": 41, "configuration_id": 343, "room_name": "Classic Studio", "property_name": "Finsbury House", "amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/finsbury-house/Classic_Studio.jpg", "source_link": "https://www.londonist.co.uk/residences/finsbury-house_16", "lease": 26, "price": 275, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "client_name": "Prestige Student "}, {"property_id": 38, "configuration_id": 347, "room_name": "Bronze Studio Mid Level", "property_name": "Highbury Residence", "amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/highbury-residence/Bronze_Studio_Mid_Level.png", "source_link": "https://www.londonist.co.uk/residences/highbury-residence_12", "lease": 26, "price": 420, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "client_name": "Prestige Student "}, {"property_id": 33, "configuration_id": 395, "room_name": "Bronze Studio Upper Level", "property_name": "Islington Residence", "amenities": ["Wardrobe", "Study desk and chair"], "room_kind": "STUDIO", "image": "", "source_link": "https://www.londonist.co.uk/residences/islington-residence_6", "lease": 26, "price": 310, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "client_name": "Prestige Student "}, {"property_id": 39, "configuration_id": 410, "room_name": "Silver Studio Lower Level", "property_name": "Highbury II Residence", "amenities": ["Wardrobe", "Study desk and chair"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/highbury-ii-residence/Silver_Studio_Lower_Level.jpg", "source_link": "https://www.londonist.co.uk/residences/highbury-ii-residence_13", "lease": 26, "price": 455, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "client_name": "Prestige Student "}]',
  timestamp: "2025-08-13T23:24:19.629000+00:00",
  quick_replies: [],
  mongo_chunk_ids: [],
  is_message_too_long: false,
  end_of_conversation: false,
  template_meta_data: {},
  template_content:
    "Based on what you're looking for, a studio room in London with a budget of £400 per week and a 6-month lease, We have the options that are the Perfect match to your requirements",
  media_expiry_time: "2025-08-20T23:24:19.629000+00:00",
  is_template_message: false,
};

const PROPERTY_CAROUSEL_TRANSLATED_DATA = {
  channel: "widget",
  message_id: "689d1e8ad006cde0e070cb86_5",
  id: "d8708b4f-48c1-4eeb-b289-18816995bdee",
  ai_response_time_in_seconds: 23.188656,
  content:
    "根据您的需求，在伦敦租一间单间公寓，预算为 400 英镑，租期为 26 周，学生可以考虑我们提供最符合您要求的选择",
  transcript_text:
    "Thank you, Aakash! It's lovely to assist you. We've noted your preferences for a studio room near University College London, with a 6-month stay and a budget of £400 per week. Here are some fantastic options that might suit your needs:\n\n*   **Islington II**\n    *   Room Name: Bronze Studio\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £375/week\n    *   Residence Link: https://londonist.co.uk/residences/islington-ii_42?&academic_year_id=8\n\n*   **Islington Residence**\n    *   Room Name: Gold Ensuite Mid Level\n    *   Room Type: ENSUITE\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £400/week\n    *   Residence Link: https://www.londonist.co.uk/residences/islington-residence_6\n\n*   **Seven Sisters**\n    *   Room Name: Bronze Accessible Studio\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £400/week\n    *   Residence Link: https://londonist.co.uk/residences/seven-sisters_525?&academic_year_id=8\n\n*   **Highbury Residence**\n    *   Room Name: Bronze Studio Mid Level\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £420/week\n    *   Residence Link: https://www.londonist.co.uk/residences/highbury-residence_12\n\n*   **Finsbury House**\n    *   Room Name: Premium Studio\n    *   Room Type: STUDIO\n    *   Max Lease: 26 weeks\n    *   Min Lease: 13 weeks\n    *   Price Range: £425/week\n    *   Residence Link: https://www.londonist.co.uk/residences/finsbury-house_16\n\nWe offer airport pickup service as well, and you can get great discounts on the properties when booking with us. Do you want to know more about us?\n\n_Note: The availability and pricing depends on your requirements and subject to change without prior notice._",
  role: "assistant",
  cc: [],
  bcc: [],
  attachments: [],
  bot_version: "v1",
  translated_content:
    "Based on what you're looking for, a studio room in London with a budget of £400 and a 26-week lease as a student, We have the options that are the Perfect match to your requirements",
  language: "zh",
  kind: "chat",
  property_json:
    '[{"property_id": 170, "configuration_id": 310, "room_name": "Bronze Studio", "property_name": "Islington II", "amenities": ["\\u8863\\u67dc", "\\u4e66\\u684c\\u548c\\u6905\\u5b50", "\\u5fae\\u6ce2", "\\u6563\\u70ed\\u5668", "\\u5e8a\\u4e0a\\u7528\\u54c1\\u5305"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/islington-ii/Bronze_Studio.jpeg", "source_link": "https://londonist.co.uk/residences/islington-ii_42?&academic_year_id=8", "lease": 26, "price": 375.0, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "translated_amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"]}, {"property_id": 33, "configuration_id": 409, "room_name": "Gold Ensuite Mid Level", "property_name": "Islington Residence", "amenities": ["\\u8863\\u67dc", "\\u4e66\\u684c\\u548c\\u6905\\u5b50"], "room_kind": "ENSUITE", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/islington-residence/Gold_Ensuite_Mid_Level.jpg", "source_link": "https://www.londonist.co.uk/residences/islington-residence_6", "lease": 26, "price": 400.0, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "translated_amenities": ["Wardrobe", "Study desk and chair"]}, {"property_id": 164, "configuration_id": 331, "room_name": "Bronze Accessible Studio", "property_name": "Seven Sisters", "amenities": ["\\u8863\\u67dc", "\\u4e66\\u684c\\u548c\\u6905\\u5b50", "\\u5fae\\u6ce2", "\\u6563\\u70ed\\u5668", "\\u5e8a\\u4e0a\\u7528\\u54c1\\u5305"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/seven-sisters/Bronze_Accessible_Studio.jpg", "source_link": "https://londonist.co.uk/residences/seven-sisters_525?&academic_year_id=8", "lease": 26, "price": 400.0, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "translated_amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"]}, {"property_id": 38, "configuration_id": 347, "room_name": "Bronze Studio Mid Level", "property_name": "Highbury Residence", "amenities": ["\\u8863\\u67dc", "\\u4e66\\u684c\\u548c\\u6905\\u5b50", "\\u5fae\\u6ce2", "\\u6563\\u70ed\\u5668", "\\u5e8a\\u4e0a\\u7528\\u54c1\\u5305"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/highbury-residence/Bronze_Studio_Mid_Level.png", "source_link": "https://www.londonist.co.uk/residences/highbury-residence_12", "lease": 26, "price": 420.0, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "translated_amenities": ["Wardrobe", "Study desk and chair", "Microwave", "Radiator", "Bedding Pack"]}, {"property_id": 41, "configuration_id": 342, "room_name": "Premium Studio", "property_name": "Finsbury House", "amenities": ["\\u8863\\u67dc", "\\u4e66\\u684c\\u548c\\u6905\\u5b50", "\\u6563\\u70ed\\u5668", "\\u5fae\\u6ce2", "\\u5e8a\\u4e0a\\u7528\\u54c1\\u5305"], "room_kind": "STUDIO", "image": "https://vf-pms.s3.eu-west-2.amazonaws.com/property-media/Londonist/finsbury-house/Premium_Studio.jpg", "source_link": "https://www.londonist.co.uk/residences/finsbury-house_16", "lease": 26, "price": 425.0, "sold_out": false, "billing_unit": "WEEK", "currency": "\\u00a3", "translated_amenities": ["Wardrobe", "Study desk and chair", "Radiator", "Microwave", "Bedding Pack"]}]',
  timestamp: "2025-08-14T01:13:57.747000+00:00",
  quick_replies: [],
  mongo_chunk_ids: [],
  is_message_too_long: false,
  end_of_conversation: false,
  template_meta_data: {},
  template_content:
    "Based on what you're looking for, a studio room in London with a budget of £400 and a 26-week lease as a student, We have the options that are the Perfect match to your requirements",
  media_expiry_time: "2025-08-21T01:13:57.747000+00:00",
  is_template_message: false,
};

const ToolbarSchema = {
  history: true,
  typography: {
    fontFamily: true,
    fontSize: true,
  },
  textFormatting: {
    bold: true,
    italic: true,
    underline: true,
    strikethrough: true,
  },
  textStyling: {
    textColor: true,
  },
  contentStructure: {
    lists: true,
    alignment: true,
    indentation: true,
    blockquotes: true,
  },
  media: {
    links: true,
    images: false,
    attachments: true,
  },
  interactive: {
    emojis: true,
  },
  utilities: {
    clearFormatting: true,
  },
  mentions: {
    mentions: true,
  },
};

const Test = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const [leadSuggestions, setLeadSuggestions] = useState<SuggestionItem[]>([]);
  const [isSearchingLeads, setIsSearchingLeads] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string | null>("active");
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  console.log("selectedUsers", selectedUsers);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [apiUsers, setApiUsers] = useState<string[]>([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState<string | null>(null);
  const [selectedApiCampaign, setSelectedApiCampaign] = useState<string | null>(
    null
  );
  const [phoneNumber, setPhoneNumber] = useState<PhoneNumberData | undefined>(
    undefined
  );
  const [selectedCountry, setSelectedCountry] = useState<CountryOption | null>(
    null
  );
  const [phoneInput, setPhoneInput] = useState("");
  const [validationError, setValidationError] = useState<string>("");
  const [leadsLoading, setLeadsLoading] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState<string>("");
  const [openChatExportModal, setOpenChatExportModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [openDurationPopper, setOpenDurationPopper] = useState(false);
  const [selectedTime, setSelectedTime] = useState<string>("");

  const [message, setMessage] = useState("");
  const [editor, setEditor] = useState<Editor | null>(null);

  const transformedCountryOptions = transformCountryOptions(countryOptions);
  const sortedCountryOptions = sortCountryOptions(transformedCountryOptions);

  useEffect(() => {
    if (!phoneNumber?.countryCode && !selectedCountry) {
      const defaultCountryOption = findCountryByCode(
        "GB",
        transformedCountryOptions
      );
      if (defaultCountryOption) {
        setSelectedCountry(defaultCountryOption);
      }
    }
  }, [phoneNumber?.countryCode, selectedCountry, transformedCountryOptions]);

  useEffect(() => {
    if (phoneNumber) {
      if (
        phoneNumber.countryCode &&
        (!selectedCountry || selectedCountry.value !== phoneNumber.countryCode)
      ) {
        const countryOption = findCountryByCode(
          phoneNumber.countryCode,
          transformedCountryOptions
        );
        if (countryOption) {
          setSelectedCountry(countryOption);
        }
      }

      if (phoneNumber.phoneNumber !== undefined) {
        const targetCountry =
          selectedCountry ||
          (phoneNumber.countryCode
            ? findCountryByCode(
                phoneNumber.countryCode,
                transformedCountryOptions
              )
            : null);
        if (targetCountry) {
          const formatted = formatPhoneNumber(
            phoneNumber.phoneNumber,
            targetCountry
          );
          setPhoneInput(formatted);
        } else {
          setPhoneInput(phoneNumber.phoneNumber);
        }
      }
    }
  }, [phoneNumber, selectedCountry, transformedCountryOptions]);

  const handlePhoneInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const digitsOnly = inputValue.replace(/\D/g, "");
    const formattedNumber = formatPhoneNumber(digitsOnly, selectedCountry);
    setPhoneInput(formattedNumber);

    const phoneData = validatePhoneNumber(digitsOnly, selectedCountry);

    if (digitsOnly && !phoneData.isValid) {
      setValidationError("Please enter a valid phone number");
    } else {
      setValidationError("");
    }

    setPhoneNumber({
      ...phoneData,
      phoneNumber: digitsOnly,
    });
  };

  const handleCountryChange = (country: CountryOption) => {
    setSelectedCountry(country);

    if (phoneInput) {
      const digitsOnly = phoneInput.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly, country);
      setPhoneInput(formattedNumber);

      const phoneData = validatePhoneNumber(digitsOnly, country);

      if (digitsOnly && !phoneData.isValid) {
        setValidationError("Please enter a valid phone number");
      } else {
        setValidationError("");
      }

      setPhoneNumber({
        ...phoneData,
        phoneNumber: digitsOnly,
      });
    } else {
      const phoneData = validatePhoneNumber("", country);
      setPhoneNumber(phoneData);
    }
  };

  const handleLeadSearch = useCallback(async (query: string) => {
    setIsSearchingLeads(true);

    setTimeout(() => {
      if (!query.trim()) {
        setLeadSuggestions([]);
        setIsSearchingLeads(false);
        return;
      }

      const filtered = SEARCH_DATA.filter(
        (item) =>
          item.leadName.toLowerCase().includes(query.toLowerCase()) ||
          item.leadId.toLowerCase().includes(query.toLowerCase())
      );

      const suggestions = filtered.map(
        (item): SuggestionItem => ({
          id: item.leadId,
          value: item.leadName,
          content: (
            <div className="p-3 flex items-center justify-between">
              <div className="flex items-center gap-[5px]">
                <Avatar text={item.leadName} size={24} />
                <p className="text-data dark:text-data-dk font-medium text-md">
                  {item.leadName}
                </p>
              </div>
              <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal">
                {item.leadId}
              </p>
            </div>
          ),
        })
      );

      setLeadSuggestions(suggestions);
      setIsSearchingLeads(false);
    }, 1000);
  }, []);

  const handleLeadSelect = useCallback(
    (suggestion: string, item?: SuggestionItem) => {
      console.log("Selected lead:", suggestion, item);
    },
    []
  );

  const handleApiUserSearch = useCallback(
    async (query: string): Promise<DropdownOption[]> => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const mockApiResults = [
        {
          value: `api-user-${query}-1`,
          content: (
            <div className="flex items-center gap-2">
              <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
              <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
                API User {query} 1
              </span>
            </div>
          ),
          label: `API User ${query} 1`,
        },
        {
          value: `api-user-${query}-2`,
          content: (
            <div className="flex items-center gap-2">
              <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
              <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
                API User {query} 2
              </span>
            </div>
          ),
          label: `API User ${query} 2`,
        },
      ];

      return mockApiResults;
    },
    []
  );

  const initialUserOptions: MultiSelectDropdownOption[] = [
    {
      value: "initial-user-1",
      content: (
        <div className="flex items-center gap-2">
          <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Initial User 1
          </span>
        </div>
      ),
      label: "Initial User 1",
    },
    {
      value: "initial-user-2",
      content: (
        <div className="flex items-center gap-2">
          <UserIcon2 className="w-3 h-3 text-verba-indigo dark:text-verba-indigo-dk shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Initial User 2
          </span>
        </div>
      ),
      label: "Initial User 2",
    },
  ];

  const handleApiSearchBarSearch = useCallback(
    async (query: string): Promise<SuggestionItem[]> => {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const mockApiResults: SuggestionItem[] = [
        {
          id: `api-result-${query}-1`,
          value: `API Result ${query} 1`,
          content: (
            <div className="p-3 flex items-center justify-between">
              <div className="flex items-center gap-[5px]">
                <Avatar text={`API ${query} 1`} size={24} />
                <p className="text-data dark:text-data-dk font-medium text-md">
                  API Result {query} 1
                </p>
              </div>
              <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal">
                #API-{query}-1
              </p>
            </div>
          ),
        },
        {
          id: `api-result-${query}-2`,
          value: `API Result ${query} 2`,
          content: (
            <div className="p-3 flex items-center justify-between">
              <div className="flex items-center gap-[5px]">
                <Avatar text={`API ${query} 2`} size={24} />
                <p className="text-data dark:text-data-dk font-medium text-md">
                  API Result {query} 2
                </p>
              </div>
              <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal">
                #API-{query}-2
              </p>
            </div>
          ),
        },
      ];

      return mockApiResults;
    },
    []
  );

  const initialSearchSuggestions: SuggestionItem[] = [
    {
      id: "initial-1",
      value: "Initial Suggestion 1",
      content: (
        <div className="p-3 flex items-center justify-between">
          <div className="flex items-center gap-[5px]">
            <Avatar text="Initial 1" size={24} />
            <p className="text-data dark:text-data-dk font-medium text-md">
              Initial Suggestion 1
            </p>
          </div>
          <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal">
            #INIT-1
          </p>
        </div>
      ),
    },
    {
      id: "initial-2",
      value: "Initial Suggestion 2",
      content: (
        <div className="p-3 flex items-center justify-between">
          <div className="flex items-center gap-[5px]">
            <Avatar text="Initial 2" size={24} />
            <p className="text-data dark:text-data-dk font-medium text-md">
              Initial Suggestion 2
            </p>
          </div>
          <p className="text-md text-dark-gray dark:text-dark-gray-dk font-normal">
            #INIT-2
          </p>
        </div>
      ),
    },
  ];

  const campaignOptions: SearchableDropdownOption[] = [
    {
      value: "email-campaign",
      content: (
        <div className="flex items-center gap-2">
          <EmailIcon className="w-3 h-3 text-blue-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Email Marketing Campaign
          </span>
        </div>
      ),
      label: "Email Marketing Campaign",
    },
    {
      value: "phone-campaign",
      content: (
        <div className="flex items-center gap-2">
          <PhoneIcon className="w-3 h-3 text-green-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Phone Outreach Campaign
          </span>
        </div>
      ),
      label: "Phone Outreach Campaign",
    },
    {
      value: "scheduled-campaign",
      content: (
        <div className="flex items-center gap-2">
          <CalendarFilledIcon className="w-3 h-3 text-purple-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Scheduled Campaign
          </span>
        </div>
      ),
      label: "Scheduled Campaign",
    },
    {
      value: "starred-campaign",
      content: (
        <div className="flex items-center gap-2">
          <StarIcon className="w-3 h-3 text-yellow-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Starred Campaign
          </span>
        </div>
      ),
      label: "Starred Campaign",
    },
    {
      value: "bookmarked-campaign",
      content: (
        <div className="flex items-center gap-2">
          <BookmarkIcon className="w-3 h-3 text-indigo-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Bookmarked Campaign
          </span>
        </div>
      ),
      label: "Bookmarked Campaign",
    },
    {
      value: "notification-campaign",
      content: (
        <div className="flex items-center gap-2">
          <BackspaceFilledIcon className="w-3 h-3 text-cyan-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Notification Campaign
          </span>
        </div>
      ),
      label: "Notification Campaign",
    },
    {
      value: "recent-campaign",
      content: (
        <div className="flex items-center gap-2">
          <ClockFilledIcon className="w-3 h-3 text-gray-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Recent Campaign
          </span>
        </div>
      ),
      label: "Recent Campaign",
    },
  ];

  const handleApiCampaignSearch = useCallback(
    async (query: string): Promise<SearchableDropdownOption[]> => {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const mockApiResults: SearchableDropdownOption[] = [
        {
          value: `api-campaign-${query}-1`,
          content: (
            <div className="flex items-center gap-2">
              <EmailIcon className="w-3 h-3 text-blue-500 shrink-0" />
              <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
                API Campaign {query} 1
              </span>
            </div>
          ),
          label: `API Campaign ${query} 1`,
        },
        {
          value: `api-campaign-${query}-2`,
          content: (
            <div className="flex items-center gap-2">
              <PhoneIcon className="w-3 h-3 text-green-500 shrink-0" />
              <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
                API Campaign {query} 2
              </span>
            </div>
          ),
          label: `API Campaign ${query} 2`,
        },
        {
          value: `api-campaign-${query}-3`,
          content: (
            <div className="flex items-center gap-2">
              <CalendarFilledIcon className="w-3 h-3 text-purple-500 shrink-0" />
              <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
                API Campaign {query} 3
              </span>
            </div>
          ),
          label: `API Campaign ${query} 3`,
        },
      ];

      return mockApiResults;
    },
    []
  );

  const initialCampaignOptions: SearchableDropdownOption[] = [
    {
      value: "initial-campaign-1",
      content: (
        <div className="flex items-center gap-2">
          <StarIcon className="w-3 h-3 text-yellow-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Initial Campaign 1
          </span>
        </div>
      ),
      label: "Initial Campaign 1",
    },
    {
      value: "initial-campaign-2",
      content: (
        <div className="flex items-center gap-2">
          <BookmarkIcon className="w-3 h-3 text-indigo-500 shrink-0" />
          <span className="overflow-hidden text-ellipsis whitespace-nowrap min-w-0 text-md text-heading-text dark:text-heading-text-dk">
            Initial Campaign 2
          </span>
        </div>
      ),
      label: "Initial Campaign 2",
    },
  ];

  const handleLeadCardSelect = (leadId: string) => {
    setSelectedLeadId(leadId);
  };

  const handleCopyLeadId = (leadId: string) => {
    navigator.clipboard.writeText(leadId);
  };

  const simulateLeadsLoading = () => {
    setLeadsLoading(true);
    setTimeout(() => {
      setLeadsLoading(false);
    }, 3000);
  };

  const handleEditorReady = (editorInstance: Editor) => {
    setEditor(editorInstance);
  };

  return (
    <div className="flex w-full h-full bg-pure-white dark:bg-pure-white-dk">
      <div className="flex flex-col gap-5 px-5 py-10 w-1/2 h-full overflow-auto no-scrollbar">
        <div className="flex items-center gap-5">
          <Button
            innerText="Save"
            isLoading={false}
            Icon={AlertIcon}
            iconClass="w-4 h-4"
            loaderSize={16}
            buttonContainerClass="w-full h-fit px-4 py-2 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
          />
          <Button
            innerText="Save"
            isLoading={true}
            Icon={AlertIcon}
            iconClass="w-4 h-4"
            loaderSize={16}
            buttonContainerClass="w-full h-fit px-4 py-2 disabled:opacity-80 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
          />

          <Button
            innerText="Open Drawer"
            onClick={() => setOpenDrawer(true)}
            isLoading={false}
            Icon={AlertIcon}
            iconClass="w-4 h-4"
            loaderSize={16}
            buttonContainerClass="w-full h-fit px-4 py-2 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
          />

          <Drawer
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
            direction="right"
            size="300px"
            overlayColor="rgba(0,0,0,0.7)"
            duration={300}
            closeOnOverlayClick={false}
            closeOnEscape={true}
            drawerContainerClassName="rounded-l-[8px]"
          >
            <div className="p-4">
              <h2 className="text-xl font-bold">Drawer Content</h2>
              <p>This drawer opens from the right.</p>
              <Button
                innerText="Close Drawer"
                onClick={() => setOpenDrawer(false)}
                isLoading={false}
                Icon={AlertIcon}
                iconClass="w-4 h-4"
                loaderSize={16}
                buttonContainerClass="w-full h-fit px-4 py-2 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
              />
            </div>
          </Drawer>
        </div>

        <div className="flex gap-5">
          <SingleDatePicker
            label="Select Date"
            labelClassName="text-heading-text dark:text-heading-text-dk text-md font-medium"
            Icon={CalendarIcon}
            value={selectedDate}
            onChange={setSelectedDate}
            disablePastDates={true}
            containerClassName="w-full"
            inputClassName="text-base font-normal text-heading-text dark:text-heading-text-dk bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk px-[12px] py-[8px] rounded-[8px]"
          />

          <Input
            label="Email"
            name="email"
            id="email"
            placeholder="Enter email address"
            containerClassName="w-full"
            labelClassName="text-heading-text dark:text-heading-text-dk text-md font-medium"
            secondaryContainerClassName="px-[10px] py-[9px] rounded-[8px] bg-popper-bg dark:bg-popper-bg-dk border border-border-gray dark:border-border-gray-dk"
          />
        </div>

        <div className="relative">
          <Button
            innerText="Open Duration Popper"
            onClick={() => setOpenDurationPopper(!openDurationPopper)}
            buttonContainerClass="w-full h-fit px-4 py-2 duration-trigger bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
          />
          <DurationPopper
            onOpen={() => setOpenDurationPopper(true)}
            triggerName="Duration"
            isOpen={openDurationPopper}
            onClose={() => setOpenDurationPopper(false)}
            onApply={(fromDate, toDate, selectedOption) => {
              console.log("Applied:", { fromDate, toDate, selectedOption });
            }}
          />
        </div>

        <TextArea
          label="Message"
          name="message"
          id="message"
          placeholder="Enter message"
          labelClassName="text-heading-text dark:text-heading-text-dk text-md font-medium"
          secondaryContainerClassName="px-[10px] py-[9px] rounded-[8px] bg-popper-bg dark:bg-popper-bg-dk border border-border-gray dark:border-border-gray-dk"
        />

        <ToggleSwitch
          isChecked={isChecked}
          handleToggle={() => setIsChecked((prev) => !prev)}
        />

        <TabPanel
          tabs={tabs}
          activeTabId={activeTab}
          onTabChange={setActiveTab}
          showIcons={false}
          showCount={true}
          showTooltips={true}
          alwaysShowLabels={true}
        >
          <div>
            {activeTab === "home" && (
              <div className="bg-amber-100 p-2">Home content here...</div>
            )}
            {activeTab === "users" && (
              <div className="bg-amber-100 p-2">Users content here...</div>
            )}
            {activeTab === "settings" && (
              <div className="bg-amber-100 p-2">Settings content here...</div>
            )}
          </div>
        </TabPanel>

        <div className="flex gap-5 w-full">
          <SearchBar
            id="lead-search"
            placeholder="Search Leads"
            suggestions={leadSuggestions}
            loading={isSearchingLeads}
            noSuggestionsText="No leads found"
            onSearch={handleLeadSearch}
            onSelect={handleLeadSelect}
            debounceMs={500}
            minCharsToSearch={1}
            suggestionsClassName="max-h-[300px]"
            containerClassName="flex-1"
          />

          <SearchBar
            id="api-lead-search"
            placeholder="Search with API"
            enableApiSearch={true}
            onApiSearch={handleApiSearchBarSearch}
            initialSuggestions={initialSearchSuggestions}
            apiSearchDebounceMs={800}
            noSuggestionsText="No API results found"
            onSelect={handleLeadSelect}
            minCharsToSearch={1}
            suggestionsClassName="max-h-[300px]"
            containerClassName="flex-1"
          />
        </div>

        <div className="flex gap-5">
          <div>
            <Dropdown
              id="priority-dropdown"
              label="Priority Level"
              options={priorityOptions}
              value={selectedPriority}
              onChange={(value) => setSelectedPriority(value)}
              placeholder="Select priority level"
              ariaLabel="Select priority level"
              className="min-w-[200px]"
            />
          </div>
          <div>
            <Dropdown
              id="status-dropdown"
              label="Status"
              options={statusOptions}
              value={selectedStatus}
              onChange={(value) => setSelectedStatus(value)}
              placeholder="Select status"
              ariaLabel="Select status"
              className="min-w-[200px]"
            />
          </div>
        </div>

        <div>
          <div
            className={`flex-1 overflow-y-auto border border-gray-300 rounded-[4px] p-2 `}
          >
            <RichTextEditor
              message={message}
              onMessageChange={setMessage}
              onEditorReady={handleEditorReady}
              placeholder="Enter your email signature here..."
            />
          </div>
          {editor && (
            <div>
              <RichTextEditorToolbar
                editor={editor}
                schema={ToolbarSchema}
                toolbarExtraClass="w-full max-w-none !ml-0 !my-0 shadow-none"
              />
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col gap-5 px-5 py-10 w-1/2 h-full overflow-auto no-scrollbar">
        <div className="flex gap-5">
          <MultiSelectSearchableDropdown
            id="users-multiselect"
            label="Select Users"
            options={userOptions}
            value={selectedUsers}
            onChange={(values) => setSelectedUsers(values)}
            placeholder="Select users"
            searchPlaceholder="Search users..."
            maxDisplayedSelections={2}
            showSearch={true}
            className="w-[300px]"
          />

          <MultiSelectSearchableDropdown
            id="categories-multiselect"
            label="Select Categories"
            options={categoryOptions}
            value={selectedCategories}
            onChange={(values) => setSelectedCategories(values)}
            placeholder="Select categories"
            maxDisplayedSelections={3}
            showSearch={false}
            className="w-[300px]"
          />
        </div>

        <div className="flex gap-5">
          <MultiSelectSearchableDropdown
            id="api-users-multiselect"
            label="API Search Users"
            options={[]}
            value={apiUsers}
            onChange={(values) => setApiUsers(values)}
            placeholder="Search and select users"
            searchPlaceholder="Type to search users..."
            maxDisplayedSelections={2}
            showSearch={true}
            className="w-[300px]"
            enableApiSearch={true}
            onSearch={handleApiUserSearch}
            initialOptions={initialUserOptions}
            searchDebounceMs={800}
            noResultsText="No users found"
          />
          <PhoneNumberCountryCodeSelector
            label="Phone Number"
            labelClassName="text-heading-text dark:text-heading-text-dk text-md font-medium"
            required={false}
            countryOptions={sortedCountryOptions}
            selectedCountry={selectedCountry}
            onCountryChange={handleCountryChange}
            phoneInput={phoneInput}
            onPhoneInputChange={handlePhoneInputChange}
            validationError={validationError}
            containerClassName="w-full"
            countryDropdownClassName="w-[250px]"
            phoneInputClassName="flex-1"
            countryDropdownPlaceholder="Select Country"
            countryDropdownSearchPlaceholder="Search countries..."
            countryDropdownSectionHeading="All Countries"
          />
        </div>

        <div className="flex gap-5">
          <SearchableDropdown
            id="campaign-dropdown"
            label="Select Campaign"
            options={campaignOptions}
            value={selectedCampaign}
            onChange={(value) => setSelectedCampaign(value)}
            placeholder="Select a campaign"
            searchPlaceholder="Search campaigns..."
            sectionHeading="All Campaigns"
            showSearch={true}
            className="w-[300px]"
          />

          <SearchableDropdown
            id="api-campaign-dropdown"
            label="API Search Campaign"
            options={[]}
            value={selectedApiCampaign}
            onChange={(value) => setSelectedApiCampaign(value)}
            placeholder="Search and select a campaign"
            searchPlaceholder="Type to search campaigns..."
            sectionHeading="Campaign Results"
            showSearch={true}
            enableApiSearch={true}
            onSearch={handleApiCampaignSearch}
            initialOptions={initialCampaignOptions}
            searchDebounceMs={800}
            loadingText=""
            noResultsText="No campaigns found"
            className="w-[300px]"
          />

          <TimePicker
            value={selectedTime}
            onChange={setSelectedTime}
            placeholder="Select Time"
            className="w-full h-[36px]"
            Icon={ScheduledIcon}
            iconClassName="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk"
            triggerIconClassName="w-[10px] h-[10px]"
            selectedOptionContainerClassName="w-full h-[34px] py-0"
            placeholderClassName="text-md font-normal placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk"
            optionClassName="text-md font-normal text-heading-text dark:text-heading-text-dk border-none"
          />
        </div>

        <Button
          innerText="Open Chat Export"
          onClick={() => setOpenChatExportModal(true)}
          isLoading={false}
          buttonContainerClass="w-full h-fit px-4 py-2 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
        />

        <Accordion
          items={accordionData}
          allowMultipleExpanded={true}
          allowZeroExpanded={true}
          accordionContainerClassName="w-full"
          preExpanded={["welcome-students", "personal-details"]}
        />

        <div className="flex gap-5">
          <div className="flex flex-col space-y-4 w-[280px]">
            <Button
              onClick={simulateLeadsLoading}
              innerText="Simulate Leads Loading"
              loaderSize={16}
              buttonContainerClass="w-full h-fit px-4 py-2 disabled:opacity-80 bg-verba-blue dark:bg-verba-blue-dk text-pure-white dark:text-pure-white-dk text-md rounded-[8px]"
            />

            <div>
              {leadsLoading ? (
                <>
                  <LeadCard loading={true} />
                  <LeadCard loading={true} />
                  <LeadCard loading={true} />
                  <LeadCard loading={true} />
                  <LeadCard loading={true} />
                </>
              ) : (
                <>
                  <LeadCard
                    leadName="John Smith"
                    leadId="12345678"
                    isSelected={selectedLeadId === "12345678"}
                    onClick={() => handleLeadCardSelect("12345678")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Sarah Johnson"
                    leadId="87654321"
                    isOnline={true}
                    outboundModalities={{ call: true, email: true }}
                    isSelected={selectedLeadId === "87654321"}
                    onClick={() => handleLeadCardSelect("87654321")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Maria Garcia"
                    leadId="11223344"
                    isHumanAssisted={true}
                    sourceCountry="jp"
                    latestMessage="Hi, I'm interested in your properties"
                    isSelected={selectedLeadId === "11223344"}
                    onClick={() => handleLeadCardSelect("11223344")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="David Wilson"
                    leadId="44332211"
                    isSecondaryLead={true}
                    sessionCount={3}
                    inboundModalities={{ whatsapp: true, call: true }}
                    isSelected={selectedLeadId === "44332211"}
                    onClick={() => handleLeadCardSelect("44332211")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Emma Davis"
                    leadId="33445566"
                    hasFeedback={4}
                    latestMessage="Thank you for your help!"
                    outboundModalities={{ whatsapp: true }}
                    isSelected={selectedLeadId === "33445566"}
                    onClick={() => handleLeadCardSelect("33445566")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Michael Brown"
                    leadId="99887766"
                    isOnline={true}
                    isHumanAssisted={true}
                    sourceCountry="us"
                    latestMessage="Can you send me more details about the apartment?"
                    isSecondaryLead={true}
                    sessionCount={5}
                    hasFeedback={2}
                    outboundModalities={{
                      call: true,
                      email: true,
                      whatsapp: true,
                    }}
                    inboundModalities={{
                      whatsapp: true,
                      call: true,
                      email: true,
                    }}
                    isSelected={selectedLeadId === "99887766"}
                    onClick={() => handleLeadCardSelect("99887766")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadId="55556666"
                    latestMessage="Anonymous inquiry about properties"
                    outboundModalities={{ email: true }}
                    isSelected={selectedLeadId === "55556666"}
                    onClick={() => handleLeadCardSelect("55556666")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Alexander Christopher Rodriguez Martinez"
                    leadId="77778888"
                    latestMessage="This is a very long message that should be truncated properly in the UI"
                    outboundModalities={{
                      call: true,
                      email: true,
                      whatsapp: true,
                    }}
                    isSelected={selectedLeadId === "77778888"}
                    onClick={() => handleLeadCardSelect("77778888")}
                    onCopyLeadId={handleCopyLeadId}
                  />

                  <LeadCard
                    leadName="Sophie Turner"
                    leadId="88889999"
                    inboundModalities={{ whatsapp: true, email: true }}
                    latestMessage="Received your message, thanks!"
                    isSelected={selectedLeadId === "88889999"}
                    onClick={() => handleLeadCardSelect("88889999")}
                    onCopyLeadId={handleCopyLeadId}
                  />
                </>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <TextMessageBlock
              message="Например, каков ваш бюджет, идеальное местоположение и какие-либо не подлежащие обсуждению характеристики, такие как количество спален или удобства?"
              translatedMessage="For example, what is your budget, ideal location and any non-negotiable characteristics such as number of bedrooms or amenities?"
              modality="messenger"
              isSent={true}
              showTranslate={true}
              showAiResponseTime={true}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Ok "
              modality="messenger"
              isSent={false}
              showTranslate={false}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Mainly on finding a good rental. I've been browsing listings, but I'm not sure what to prioritise."
              modality="messenger"
              isSent={false}
              showTranslate={false}
              showAiResponseTime={false}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Thank you for your inquiry. I'll get back to you within 24 hours with detailed information about the property."
              modality="email"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "Sarah Johnson",
                showOnlineStatus: true,
                isOnline: true,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Call duration: 15 minutes. Discussed property requirements and scheduled viewing."
              modality="call"
              isSent={false}
              iconType="agent"
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Hi! I'm interested in the 2-bedroom apartment you have listed. Is it still available?"
              modality="chat"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "Mike Chen",
                showOnlineStatus: true,
                isOnline: false,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="I've been looking for a property in this area for quite some time now. My requirements are quite specific - I need at least 3 bedrooms, preferably with a garden or balcony, and it must be within walking distance to public transport. My budget is around $500,000, but I'm flexible if the property is perfect. I'm particularly interested in properties with modern amenities and good energy efficiency ratings. Could you please send me some options that match these criteria?"
              translatedMessage="Я ищу недвижимость в этом районе уже довольно давно. Мои требования довольно специфичны - мне нужно как минимум 3 спальни, желательно с садом или балконом, и она должна быть в пешей доступности от общественного транспорта. Мой бюджет составляет около 500 000 долларов, но я гибкий, если недвижимость идеальна. Меня особенно интересуют объекты с современными удобствами и хорошими рейтингами энергоэффективности. Не могли бы вы прислать мне несколько вариантов, соответствующих этим критериям?"
              modality="email"
              isSent={false}
              showTranslate={true}
              iconType="participant"
              participantInfo={{
                text: "Alex Thompson",
                showOnlineStatus: false,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Yes, available."
              modality="chat"
              isSent={false}
              showAiResponseTime={false}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Perfect! I'll schedule the viewing for tomorrow at 2 PM. Please confirm if this works for you."
              modality="messenger"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "Emma Wilson",
                showOnlineStatus: true,
                isOnline: true,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Call ended. Duration: 8 minutes 32 seconds."
              modality="call"
              isSent={false}
              showAiResponseTime={false}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="I've attached the property documents and floor plans as requested. Please review them and let me know if you need any clarification."
              modality="email"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "Dr. Elizabeth Rodriguez-Martinez",
                showOnlineStatus: true,
                isOnline: true,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="Thanks!"
              modality="chat"
              isSent={true}
              iconType="participant"
              participantInfo={{
                text: "A",
                showOnlineStatus: false,
              }}
              showAiResponseTime={true}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <TextMessageBlock
              message="This message shows the Verbaflo logo."
              modality="email"
              isSent={true}
              iconType="verbaflo"
              showAiResponseTime={true}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <PropertyCardsCarousel
              property_json={JSON.parse(
                PROPERTY_CAROUSEL_DATA?.property_json as string
              )}
              showAllTranslation={true}
              modality="chat"
              iconType="verbaflo"
              showAiResponseTime={true}
              isSent={true}
              aiResponseTime={23.188656}
              timestamp="2025-08-14T01:13:57.747000+00:00"
              showTimestamp={true}
              messageId="123"
            />

            <PropertyCardsCarousel
              property_json={JSON.parse(
                PROPERTY_CAROUSEL_TRANSLATED_DATA?.property_json as string
              )}
              showAllTranslation={true}
              modality="chat"
              iconType="verbaflo"
              showAiResponseTime={true}
              isSent={true}
              aiResponseTime={23.188656}
              timestamp="2025-08-14T01:13:57.747000+00:00"
              showTimestamp={true}
              messageId="1234"
            />

            <TextMessageBlock
              message="Bonjour! Comment allez-vous aujourd'hui?"
              translatedMessage="Hello! How are you today?"
              modality="chat"
              isSent={false}
              showTranslate={true}
              iconType="participant"
              participantInfo={{
                text: "A",
                showOnlineStatus: false,
              }}
              regularMessage={{
                id: "123",
                message_id: "123",
                content: "Hello, how are you?",
                role: "user",
                kind: "text",
                timestamp: "2025-08-14T01:13:57.747000+00:00",
                transcript_text: null,
                language: "",
                template_meta_data: {},
                channel: "messenger",
              }}
              leadDetails={null}
            />

            <FeedbackMessageBlock
              modality="chat"
              rating={4}
              feedbackMessage="The AI felt conversational and easy to interact with. It understood my needs quickly and guided me step-by-step. Booking student accommodation has never been this smooth!"
              timestamp="8:30 PM"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "A",
                showOnlineStatus: false,
              }}
            />

            <AISummaryBlock
              text="The AI felt conversational and easy to interact with. It understood my needs quickly and guided me step-by-step. Booking student accommodation has never been this smooth. The AI felt conversational and easy to interact with. It understood my needs quickly and guided me step-by-step. Booking student accommodation has never been this smooth."
              title="AI Summary"
              showLogo={true}
              maxLines={2}
            />

            <AISummaryBlock
              text="The AI felt conversational and easy to interact with."
              title="AI Summary"
              showLogo={true}
              maxLines={2}
            />

            <AICallTranscript
              title="AI Call Transcript"
              showLogo={true}
              transcript={""}
            />

            <VoiceCallMessageBlock
              callStatus="initiated"
              callText="Call Initiated to John"
              messageContainerClassName="border border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk"
            />

            <VoiceCallMessageBlock
              callStatus="not-answered"
              callText="Call Not Answered"
              isSent={true}
              messageContainerClassName="border border-verba-red-alert/25 dark:border-verba-red-alert-dk/25 bg-verba-red-alert/10 dark:bg-verba-red-alert-dk/10"
            />

            <VoiceCallMessageBlock
              callStatus="initiated"
              callText="Call Initiated to John"
              showAiResponseTime={true}
              showTimestamp={true}
              messageContainerClassName="border border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk"
            />

            <VoiceCallMessageBlock
              callStatus="initiated"
              callText="Call Initiated to John"
              isOutbound={true}
              modality="call"
              iconType="participant"
              participantInfo={{
                text: "SA",
                size: 24,
                showOnlineStatus: true,
                isOnline: true,
              }}
              messageContainerClassName="border border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk"
            />

            <VoiceCallMessageBlock
              callStatus="not-answered"
              callText="Call not answered"
              isSent={false}
              iconType="agent"
              showTimestamp={true}
              messageContainerClassName="border border-verba-red-alert/25 dark:border-verba-red-alert-dk/25 bg-verba-red-alert/10 dark:bg-verba-red-alert-dk/10"
            />

            <VoiceCallMessageBlock
              callStatus="initiated"
              callText="Call Initiated to John"
              modality="call"
              iconType="verbaflo"
              showAiResponseTime={true}
              showTimestamp={true}
              messageContainerClassName="border border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk"
            />

            <VoiceCallMessageBlock
              callStatus="initiated"
              callText="Outbound Call via Messenger"
              isOutbound={true}
              modality="call"
              showTimestamp={true}
              messageContainerClassName="border border-border-gray dark:border-border-gray-dk bg-verba-pearl dark:bg-verba-pearl-dk"
            />

            <VoiceCallMessageBlock
              callStatus="not-answered"
              callText="Call not answered"
              modality="call"
              isSent={true}
              showAiResponseTime={true}
              messageContainerClassName="border border-verba-red-alert/25 dark:border-verba-red-alert-dk/25 bg-verba-red-alert/10 dark:bg-verba-red-alert-dk/10"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/outbound-call.mp3"
              duration="2:30s"
              isSent={true}
              iconType="verbaflo"
              modality="call"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/inbound-call.mp3"
              duration="5:12s"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "JD",
                size: 24,
                showOnlineStatus: true,
                isOnline: true,
              }}
              modality="call"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/agent-call.mp3"
              duration="1:45s"
              isSent={false}
              iconType="agent"
              showDownloadButton={false}
              modality="call"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/no-waveform.mp3"
              duration="0:30s"
              isSent={true}
              showWaveform={false}
              iconType="verbaflo"
              modality="call"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/custom-audio.mp3"
              duration="8:20s"
              isSent={false}
              iconType="participant"
              participantInfo={{
                text: "AB",
                size: 20,
                showOnlineStatus: true,
                isOnline: false,
              }}
              playerContainerClassName="border-2 border-verba-green-success/50 dark:border-verba-green-success-dk/50"
              onDownload={() => console.log("Custom download handler")}
              modality="call"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/email-audio.mp3"
              duration="1:15s"
              isSent={true}
              modality="call"
              showModality={true}
            />

            <VoiceCallPlayer
              audioSrc="/path/to/messenger-audio.mp3"
              duration="2:45s"
              isSent={false}
              modality="messenger"
              iconType="verbaflo"
            />

            <VoiceCallPlayer
              audioSrc="/path/to/chat-audio.mp3"
              duration="0:55s"
              isSent={true}
              modality="call"
              showModality={true}
              iconType="agent"
            />
          </div>
        </div>
      </div>

      <ChatExportModal
        open={openChatExportModal}
        onOpenChange={setOpenChatExportModal}
      />
    </div>
  );
};

export default Test;
